export default {
  metadata: {
    version: '1.0.0',
    id: 'carousel-pagination-1.0.0',
    name: 'JDSCarouselPagination'
  },
  hierarchy: {
    container: ['jds_carousel_pagination_item']
  },
  base: {
    container: {
      hidden: false,
      'flex-direction': '{c_0}',
      'justify-content': '{c_1}',
      'align-items': '{c_2}',
      gap: '{c_3}',
      'padding-top': '{c_4}',
      'padding-bottom': '{c_6}'
    },
    jds_carousel_pagination_item: {
      density: 'relaxed'
    }
  },
  variant: {
    density: {
      condensed: {
        container: {
          gap: '{c_7}'
        },
        jds_carousel_pagination_item: {
          density: 'condensed'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      density: {
        type: 'JDSCarouselPaginationItem.density',
        values: ['relaxed', 'condensed']
      }
    },
    data: {
      container: {
        value: {
          type: 'list',
          name: 'items',
          object: {
            active: 'boolean',
            kind: 'JDSCarouselPaginationItem.kind'
          }
        }
      },
      jds_carousel_pagination_item: {
        active: {
          type: 'boolean',
          name: 'items.active'
        },
        kind: {
          type: 'JDSCarouselPaginationItem.kind',
          name: 'items.kind'
        }
      }
    },
    events: {
      jds_carousel_pagination_item: {
        onDotClick: 'onDotClick'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'presentation'
          }
        }
      }
    }
  }
};
